import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/guessbtc/Down_Button.png")